module.exports = __webpack_public_path__ + "img/beach_parents.c2cd50c8.jpg";